var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"offset-md-2",attrs:{"cols":"12","md":"8"}},[_c('h1',{staticClass:"white--text text-center pa-4"},[_vm._v(" Successfully signed out ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }